import { FETCH_DIA_SIGNODE_CONNECTIONID} from "../../actionTypes";
import { fetchDiaSigNodeandConectionId } from "../../../../api/dashboard/diameter/diameter";

const request = () => ({ type: FETCH_DIA_SIGNODE_CONNECTIONID.REQUEST });
const failure = (error) => ({ type: FETCH_DIA_SIGNODE_CONNECTIONID.FAILURE, error });
const success = (data) => ({ type: FETCH_DIA_SIGNODE_CONNECTIONID.SUCCESS,data});


export const getDiaSigNodeandConectionId = (cp_name) => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchDiaSigNodeandConectionId(cp_name)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
